import React, { useState } from 'react';
import { connect } from "react-redux";
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';

import { deleteAppliance, editAppliance } from "../redux/actions";

const EnergyTable = ({ appliances, deleteAppliance, editAppliance }) => {

    const reducerKWH = (accumulator, appliance) => accumulator + parseFloat(appliance.kwh);
    const reducerCost = (accumulator, appliance) => accumulator + parseFloat(appliance.cost);

    const totalKWH =  Math.round((appliances.reduce(reducerKWH, 0) + Number.EPSILON) * 100) / 100;
    const totalCost = Math.round((appliances.reduce(reducerCost, 0) + Number.EPSILON) * 100) / 100;

    const handleDeleteAppliance = (applianceId) => {
        deleteAppliance(applianceId);
    };

    const handleEditAppliance = (applianceId) => {
        editAppliance(applianceId);
    };

    return (<Table striped bordered hover>
    <thead>
        <tr>
        <th>#</th>
        <th>Appliance</th>
        <th>kWH/Year</th>
        <th>Cost/Year</th>
        <th></th>
        </tr>
    </thead>
    <tbody>
        {appliances.map((appliance, index) => {
            return (
                <tr>
                <td>{index}</td>
                <td>{appliance.name}</td>
                <td>{appliance.kwh}</td>
                <td>{appliance.cost}</td>
                <td>
                    <Button variant="secondary" size="sm" onClick={()=>handleEditAppliance(index)}>
                        Edit
                    </Button>{' '}
                    <Button variant="secondary" size="sm" onClick={()=>handleDeleteAppliance(index)}>
                        Delete
                    </Button>
                </td>
                </tr>
            );
        })}
        <tr>
            <td></td>
            <td>Total</td>
            <td>{totalKWH}</td>
            <td>{totalCost}</td>
            <td></td>
        </tr>
    </tbody>
    </Table>);
}

const mapStateToProps = state => {
    return {appliances: state[0].appliances};
};

export default connect(mapStateToProps, { deleteAppliance, editAppliance })(EnergyTable);